import NpsByAnswerToOtherQuestionBarChart from './NpsByAnswerToOtherQuestionBarChart';
export default NpsByAnswerToOtherQuestionBarChart;



// WEBPACK FOOTER //
// ./src/components/NpsByAnswerToOtherQuestionBarChart/index.js